import { render } from "./TrekDashboard.vue?vue&type=template&id=19813495&scoped=true"
import script from "./TrekDashboard.vue?vue&type=script&lang=js"
export * from "./TrekDashboard.vue?vue&type=script&lang=js"

import "./TrekDashboard.vue?vue&type=style&index=0&id=19813495&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19813495"]])

export default __exports__